"use client";

import {
  type BaseQueryFn,
  type FetchArgs,
  fetchBaseQuery,
  type FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

import { publicConfig } from "@/configs/public-config";
import { type IApiResponseError } from "@/shared/interfaces/api-response.interface";

const publicFetchBase = fetchBaseQuery({
  baseUrl: `${publicConfig.apiUrl}/${publicConfig.apiTag}`,
});

const customPublicFetchBase: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await publicFetchBase(args, api, extraOptions);

  if (result.error) {
    const errorData = result.error.data as IApiResponseError;
    console.error("Public API Error:", errorData?.message || "Unknown error");
  }

  return result;
};

export default customPublicFetchBase;
